import { createFileRoute } from '@tanstack/react-router'

// Noop route — actual shard rendering is handled by the global ShardIframe
// component (Penpal iframe) in the shardlibrary layout.
export const Route = createFileRoute('/_auth/shardlibrary/$collectionId/$shardId')({
  component: () => null,
})
